import * as React from "react";
import IGeoFAGeneral from "../../services/interfaces/IGeoFAGeneral";

import styles from './GeoFaWidget.module.css';
import i18n from "i18next";

interface GeoFaWidgetProps {
    properties: IGeoFAGeneral
    typeCodes: number[]
    field: string
    de_field?: string
    en_field?: string
    label?: string
    dangerous?: boolean

    // If set, we translate the values, typical for fields with a limited set of results.
    translateValue?: boolean
}

const GeoFaWidget: React.FC<GeoFaWidgetProps> = ({
                                                     properties,
                                                     typeCodes,
                                                     label,
                                                     field,
                                                     de_field,
                                                     en_field,
                                                     dangerous,
                                                     translateValue
                                                 }) => {

    let temakode = properties.temakode;
    let v:any;

    if (de_field || en_field) {

        if (field === 'beskrivels' && ['de', 'de-DE', 'de-CH', 'de-AT', 'de-LI', 'de-LU'].includes(i18n.language)) {
            field = 'd_k_beskr'
        }

        if (field === 'beskrivels' && ['en', 'en-GB', 'en-US'].includes(i18n.language)) {
            field = 'uk_k_beskr';
        }

        if (field === 'lang_beskr' && ['de', 'de-DE', 'de-CH', 'de-AT', 'de-LI', 'de-LU'].includes(i18n.language)) {
            field = 'd_l_beskr'
        }

        if (field === 'lang_beskr' && ['en', 'en-GB', 'en-US'].includes(i18n.language)) {
            field = 'uk_l_beskr';
        }

    }

    if (temakode === 5802) {
        if (typeCodes.indexOf(properties.rute_ty_k)) {
            v = properties[field as keyof IGeoFAGeneral];
        }
    }

    // Point
    if (temakode === 5800) {
        if (typeCodes.indexOf(properties.rute_ty_k)) {
            v = properties[field as keyof IGeoFAGeneral];
        }
    }

    // Ladestanderpoint
    if (temakode === 5607) {
        v = properties[field as keyof IGeoFAGeneral];
    }

    function loading() {
        if (!field) {
            return styles.widget
        }
    }

    return (<div className={loading()} id={field}>
            {label && <span className={styles.label}>{label}</span>}
            { dangerous &&
                    <div className={styles.dangerousContent} dangerouslySetInnerHTML={{ __html: v }} ></div>}

            { !dangerous &&
                <div className={styles.content}>
                    {v && v}
                </div>
        }

        </div>
    )
}

export default GeoFaWidget;
